/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as AuthRouteImport } from './_auth'
import { Route as PortalRouteImport } from './_portal'
import { Route as LoginRouteImport } from './login'
import { Route as LogoutRouteImport } from './logout'
import { Route as NoAccessRouteImport } from './no-access'
import { Route as AuthIndexRouteImport } from './_auth/index'
import { Route as AuthAdminRouteImport } from './_auth/admin'
import { Route as AuthKitchenSinkRouteImport } from './_auth/kitchen-sink'
import { Route as AuthAdminIndexRouteImport } from './_auth/admin.index'
import { Route as AuthAdminAccountPopulationRouteImport } from './_auth/admin.account-population'
import { Route as AuthAdminPermissionsRouteImport } from './_auth/admin.permissions'
import { Route as AuthAdminUsersRouteImport } from './_auth/admin.users'
import { Route as AuthAgentsBrokersIndexRouteImport } from './_auth/agents-brokers/index'
import { Route as AuthClientsIndexRouteImport } from './_auth/clients/index'
import { Route as AuthEntitiesIndexRouteImport } from './_auth/entities/index'
import { Route as AuthEntityContractsIndexRouteImport } from './_auth/entity-contracts/index'
import { Route as AuthGeneralAgentsIndexRouteImport } from './_auth/general-agents/index'
import { Route as AuthInvoicesIndexRouteImport } from './_auth/invoices/index'
import { Route as AuthInvoicesInvoiceIdRouteImport } from './_auth/invoices/$invoiceId'
import { Route as AuthProvidersIndexRouteImport } from './_auth/providers/index'
import { Route as AuthTpasIndexRouteImport } from './_auth/tpas/index'
import { Route as PortalPortalBankAccountsRouteImport } from './_portal/portal/bank-accounts'
import { Route as PortalPortalNotificationsRouteImport } from './_portal/portal/notifications'
import { Route as PortalPortalSummaryRouteImport } from './_portal/portal/summary'
import { Route as AuthAgentsBrokersAgentBrokerIdIndexRouteImport } from './_auth/agents-brokers/$agentBrokerId/index'
import { Route as AuthAgentsBrokersAgentBrokerIdSectionRouteImport } from './_auth/agents-brokers/$agentBrokerId/$section'
import { Route as AuthEntitiesEntityIdIndexRouteImport } from './_auth/entities/$entityId/index'
import { Route as AuthEntitiesEntityIdSectionRouteImport } from './_auth/entities/$entityId/$section'
import { Route as AuthGeneralAgentsGeneralAgentIdIndexRouteImport } from './_auth/general-agents/$generalAgentId/index'
import { Route as AuthGeneralAgentsGeneralAgentIdSectionRouteImport } from './_auth/general-agents/$generalAgentId/$section'
import { Route as AuthProvidersProviderIdIndexRouteImport } from './_auth/providers/$providerId/index'
import { Route as AuthProvidersProviderIdSectionRouteImport } from './_auth/providers/$providerId/$section'
import { Route as AuthTpasTpaIdIndexRouteImport } from './_auth/tpas/$tpaId/index'
import { Route as AuthTpasTpaIdSectionRouteImport } from './_auth/tpas/$tpaId/$section'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/_portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKitchenSinkRoute = AuthKitchenSinkRouteImport.update({
  id: '/kitchen-sink',
  path: '/kitchen-sink',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminAccountPopulationRoute =
  AuthAdminAccountPopulationRouteImport.update({
    id: '/account-population',
    path: '/account-population',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminPermissionsRoute = AuthAdminPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminUsersRoute = AuthAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAgentsBrokersIndexRoute = AuthAgentsBrokersIndexRouteImport.update({
  id: '/agents-brokers/',
  path: '/agents-brokers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsIndexRoute = AuthClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEntitiesIndexRoute = AuthEntitiesIndexRouteImport.update({
  id: '/entities/',
  path: '/entities/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEntityContractsIndexRoute =
  AuthEntityContractsIndexRouteImport.update({
    id: '/entity-contracts/',
    path: '/entity-contracts/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeneralAgentsIndexRoute = AuthGeneralAgentsIndexRouteImport.update({
  id: '/general-agents/',
  path: '/general-agents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesIndexRoute = AuthInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesInvoiceIdRoute = AuthInvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProvidersIndexRoute = AuthProvidersIndexRouteImport.update({
  id: '/providers/',
  path: '/providers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTpasIndexRoute = AuthTpasIndexRouteImport.update({
  id: '/tpas/',
  path: '/tpas/',
  getParentRoute: () => AuthRoute,
} as any)
const PortalPortalBankAccountsRoute =
  PortalPortalBankAccountsRouteImport.update({
    id: '/portal/bank-accounts',
    path: '/portal/bank-accounts',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalPortalNotificationsRoute =
  PortalPortalNotificationsRouteImport.update({
    id: '/portal/notifications',
    path: '/portal/notifications',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalPortalSummaryRoute = PortalPortalSummaryRouteImport.update({
  id: '/portal/summary',
  path: '/portal/summary',
  getParentRoute: () => PortalRoute,
} as any)
const AuthAgentsBrokersAgentBrokerIdIndexRoute =
  AuthAgentsBrokersAgentBrokerIdIndexRouteImport.update({
    id: '/agents-brokers/$agentBrokerId/',
    path: '/agents-brokers/$agentBrokerId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAgentsBrokersAgentBrokerIdSectionRoute =
  AuthAgentsBrokersAgentBrokerIdSectionRouteImport.update({
    id: '/agents-brokers/$agentBrokerId/$section',
    path: '/agents-brokers/$agentBrokerId/$section',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEntitiesEntityIdIndexRoute =
  AuthEntitiesEntityIdIndexRouteImport.update({
    id: '/entities/$entityId/',
    path: '/entities/$entityId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEntitiesEntityIdSectionRoute =
  AuthEntitiesEntityIdSectionRouteImport.update({
    id: '/entities/$entityId/$section',
    path: '/entities/$entityId/$section',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeneralAgentsGeneralAgentIdIndexRoute =
  AuthGeneralAgentsGeneralAgentIdIndexRouteImport.update({
    id: '/general-agents/$generalAgentId/',
    path: '/general-agents/$generalAgentId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeneralAgentsGeneralAgentIdSectionRoute =
  AuthGeneralAgentsGeneralAgentIdSectionRouteImport.update({
    id: '/general-agents/$generalAgentId/$section',
    path: '/general-agents/$generalAgentId/$section',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProvidersProviderIdIndexRoute =
  AuthProvidersProviderIdIndexRouteImport.update({
    id: '/providers/$providerId/',
    path: '/providers/$providerId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProvidersProviderIdSectionRoute =
  AuthProvidersProviderIdSectionRouteImport.update({
    id: '/providers/$providerId/$section',
    path: '/providers/$providerId/$section',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthTpasTpaIdIndexRoute = AuthTpasTpaIdIndexRouteImport.update({
  id: '/tpas/$tpaId/',
  path: '/tpas/$tpaId/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTpasTpaIdSectionRoute = AuthTpasTpaIdSectionRouteImport.update({
  id: '/tpas/$tpaId/$section',
  path: '/tpas/$tpaId/$section',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/no-access': typeof NoAccessRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/kitchen-sink': typeof AuthKitchenSinkRoute
  '/admin/account-population': typeof AuthAdminAccountPopulationRoute
  '/admin/permissions': typeof AuthAdminPermissionsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/invoices/$invoiceId': typeof AuthInvoicesInvoiceIdRoute
  '/portal/bank-accounts': typeof PortalPortalBankAccountsRoute
  '/portal/notifications': typeof PortalPortalNotificationsRoute
  '/portal/summary': typeof PortalPortalSummaryRoute
  '/admin/': typeof AuthAdminIndexRoute
  '/agents-brokers/': typeof AuthAgentsBrokersIndexRoute
  '/clients/': typeof AuthClientsIndexRoute
  '/entities/': typeof AuthEntitiesIndexRoute
  '/entity-contracts/': typeof AuthEntityContractsIndexRoute
  '/general-agents/': typeof AuthGeneralAgentsIndexRoute
  '/invoices/': typeof AuthInvoicesIndexRoute
  '/providers/': typeof AuthProvidersIndexRoute
  '/tpas/': typeof AuthTpasIndexRoute
  '/agents-brokers/$agentBrokerId/$section': typeof AuthAgentsBrokersAgentBrokerIdSectionRoute
  '/entities/$entityId/$section': typeof AuthEntitiesEntityIdSectionRoute
  '/general-agents/$generalAgentId/$section': typeof AuthGeneralAgentsGeneralAgentIdSectionRoute
  '/providers/$providerId/$section': typeof AuthProvidersProviderIdSectionRoute
  '/tpas/$tpaId/$section': typeof AuthTpasTpaIdSectionRoute
  '/agents-brokers/$agentBrokerId/': typeof AuthAgentsBrokersAgentBrokerIdIndexRoute
  '/entities/$entityId/': typeof AuthEntitiesEntityIdIndexRoute
  '/general-agents/$generalAgentId/': typeof AuthGeneralAgentsGeneralAgentIdIndexRoute
  '/providers/$providerId/': typeof AuthProvidersProviderIdIndexRoute
  '/tpas/$tpaId/': typeof AuthTpasTpaIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/no-access': typeof NoAccessRoute
  '/kitchen-sink': typeof AuthKitchenSinkRoute
  '/admin/account-population': typeof AuthAdminAccountPopulationRoute
  '/admin/permissions': typeof AuthAdminPermissionsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/invoices/$invoiceId': typeof AuthInvoicesInvoiceIdRoute
  '/portal/bank-accounts': typeof PortalPortalBankAccountsRoute
  '/portal/notifications': typeof PortalPortalNotificationsRoute
  '/portal/summary': typeof PortalPortalSummaryRoute
  '/admin': typeof AuthAdminIndexRoute
  '/agents-brokers': typeof AuthAgentsBrokersIndexRoute
  '/clients': typeof AuthClientsIndexRoute
  '/entities': typeof AuthEntitiesIndexRoute
  '/entity-contracts': typeof AuthEntityContractsIndexRoute
  '/general-agents': typeof AuthGeneralAgentsIndexRoute
  '/invoices': typeof AuthInvoicesIndexRoute
  '/providers': typeof AuthProvidersIndexRoute
  '/tpas': typeof AuthTpasIndexRoute
  '/agents-brokers/$agentBrokerId/$section': typeof AuthAgentsBrokersAgentBrokerIdSectionRoute
  '/entities/$entityId/$section': typeof AuthEntitiesEntityIdSectionRoute
  '/general-agents/$generalAgentId/$section': typeof AuthGeneralAgentsGeneralAgentIdSectionRoute
  '/providers/$providerId/$section': typeof AuthProvidersProviderIdSectionRoute
  '/tpas/$tpaId/$section': typeof AuthTpasTpaIdSectionRoute
  '/agents-brokers/$agentBrokerId': typeof AuthAgentsBrokersAgentBrokerIdIndexRoute
  '/entities/$entityId': typeof AuthEntitiesEntityIdIndexRoute
  '/general-agents/$generalAgentId': typeof AuthGeneralAgentsGeneralAgentIdIndexRoute
  '/providers/$providerId': typeof AuthProvidersProviderIdIndexRoute
  '/tpas/$tpaId': typeof AuthTpasTpaIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_portal': typeof PortalRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/no-access': typeof NoAccessRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/kitchen-sink': typeof AuthKitchenSinkRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/account-population': typeof AuthAdminAccountPopulationRoute
  '/_auth/admin/permissions': typeof AuthAdminPermissionsRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/invoices/$invoiceId': typeof AuthInvoicesInvoiceIdRoute
  '/_portal/portal/bank-accounts': typeof PortalPortalBankAccountsRoute
  '/_portal/portal/notifications': typeof PortalPortalNotificationsRoute
  '/_portal/portal/summary': typeof PortalPortalSummaryRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/agents-brokers/': typeof AuthAgentsBrokersIndexRoute
  '/_auth/clients/': typeof AuthClientsIndexRoute
  '/_auth/entities/': typeof AuthEntitiesIndexRoute
  '/_auth/entity-contracts/': typeof AuthEntityContractsIndexRoute
  '/_auth/general-agents/': typeof AuthGeneralAgentsIndexRoute
  '/_auth/invoices/': typeof AuthInvoicesIndexRoute
  '/_auth/providers/': typeof AuthProvidersIndexRoute
  '/_auth/tpas/': typeof AuthTpasIndexRoute
  '/_auth/agents-brokers/$agentBrokerId/$section': typeof AuthAgentsBrokersAgentBrokerIdSectionRoute
  '/_auth/entities/$entityId/$section': typeof AuthEntitiesEntityIdSectionRoute
  '/_auth/general-agents/$generalAgentId/$section': typeof AuthGeneralAgentsGeneralAgentIdSectionRoute
  '/_auth/providers/$providerId/$section': typeof AuthProvidersProviderIdSectionRoute
  '/_auth/tpas/$tpaId/$section': typeof AuthTpasTpaIdSectionRoute
  '/_auth/agents-brokers/$agentBrokerId/': typeof AuthAgentsBrokersAgentBrokerIdIndexRoute
  '/_auth/entities/$entityId/': typeof AuthEntitiesEntityIdIndexRoute
  '/_auth/general-agents/$generalAgentId/': typeof AuthGeneralAgentsGeneralAgentIdIndexRoute
  '/_auth/providers/$providerId/': typeof AuthProvidersProviderIdIndexRoute
  '/_auth/tpas/$tpaId/': typeof AuthTpasTpaIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/no-access'
    | '/admin'
    | '/kitchen-sink'
    | '/admin/account-population'
    | '/admin/permissions'
    | '/admin/users'
    | '/invoices/$invoiceId'
    | '/portal/bank-accounts'
    | '/portal/notifications'
    | '/portal/summary'
    | '/admin/'
    | '/agents-brokers/'
    | '/clients/'
    | '/entities/'
    | '/entity-contracts/'
    | '/general-agents/'
    | '/invoices/'
    | '/providers/'
    | '/tpas/'
    | '/agents-brokers/$agentBrokerId/$section'
    | '/entities/$entityId/$section'
    | '/general-agents/$generalAgentId/$section'
    | '/providers/$providerId/$section'
    | '/tpas/$tpaId/$section'
    | '/agents-brokers/$agentBrokerId/'
    | '/entities/$entityId/'
    | '/general-agents/$generalAgentId/'
    | '/providers/$providerId/'
    | '/tpas/$tpaId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/no-access'
    | '/kitchen-sink'
    | '/admin/account-population'
    | '/admin/permissions'
    | '/admin/users'
    | '/invoices/$invoiceId'
    | '/portal/bank-accounts'
    | '/portal/notifications'
    | '/portal/summary'
    | '/admin'
    | '/agents-brokers'
    | '/clients'
    | '/entities'
    | '/entity-contracts'
    | '/general-agents'
    | '/invoices'
    | '/providers'
    | '/tpas'
    | '/agents-brokers/$agentBrokerId/$section'
    | '/entities/$entityId/$section'
    | '/general-agents/$generalAgentId/$section'
    | '/providers/$providerId/$section'
    | '/tpas/$tpaId/$section'
    | '/agents-brokers/$agentBrokerId'
    | '/entities/$entityId'
    | '/general-agents/$generalAgentId'
    | '/providers/$providerId'
    | '/tpas/$tpaId'
  id:
    | '__root__'
    | '/_auth'
    | '/_portal'
    | '/login'
    | '/logout'
    | '/no-access'
    | '/_auth/admin'
    | '/_auth/kitchen-sink'
    | '/_auth/'
    | '/_auth/admin/account-population'
    | '/_auth/admin/permissions'
    | '/_auth/admin/users'
    | '/_auth/invoices/$invoiceId'
    | '/_portal/portal/bank-accounts'
    | '/_portal/portal/notifications'
    | '/_portal/portal/summary'
    | '/_auth/admin/'
    | '/_auth/agents-brokers/'
    | '/_auth/clients/'
    | '/_auth/entities/'
    | '/_auth/entity-contracts/'
    | '/_auth/general-agents/'
    | '/_auth/invoices/'
    | '/_auth/providers/'
    | '/_auth/tpas/'
    | '/_auth/agents-brokers/$agentBrokerId/$section'
    | '/_auth/entities/$entityId/$section'
    | '/_auth/general-agents/$generalAgentId/$section'
    | '/_auth/providers/$providerId/$section'
    | '/_auth/tpas/$tpaId/$section'
    | '/_auth/agents-brokers/$agentBrokerId/'
    | '/_auth/entities/$entityId/'
    | '/_auth/general-agents/$generalAgentId/'
    | '/_auth/providers/$providerId/'
    | '/_auth/tpas/$tpaId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PortalRoute: typeof PortalRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  NoAccessRoute: typeof NoAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal': {
      id: '/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kitchen-sink': {
      id: '/_auth/kitchen-sink'
      path: '/kitchen-sink'
      fullPath: '/kitchen-sink'
      preLoaderRoute: typeof AuthKitchenSinkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/account-population': {
      id: '/_auth/admin/account-population'
      path: '/account-population'
      fullPath: '/admin/account-population'
      preLoaderRoute: typeof AuthAdminAccountPopulationRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/permissions': {
      id: '/_auth/admin/permissions'
      path: '/permissions'
      fullPath: '/admin/permissions'
      preLoaderRoute: typeof AuthAdminPermissionsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/agents-brokers/': {
      id: '/_auth/agents-brokers/'
      path: '/agents-brokers'
      fullPath: '/agents-brokers/'
      preLoaderRoute: typeof AuthAgentsBrokersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/': {
      id: '/_auth/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthClientsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/entities/': {
      id: '/_auth/entities/'
      path: '/entities'
      fullPath: '/entities/'
      preLoaderRoute: typeof AuthEntitiesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/entity-contracts/': {
      id: '/_auth/entity-contracts/'
      path: '/entity-contracts'
      fullPath: '/entity-contracts/'
      preLoaderRoute: typeof AuthEntityContractsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/general-agents/': {
      id: '/_auth/general-agents/'
      path: '/general-agents'
      fullPath: '/general-agents/'
      preLoaderRoute: typeof AuthGeneralAgentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/': {
      id: '/_auth/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthInvoicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/$invoiceId': {
      id: '/_auth/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/providers/': {
      id: '/_auth/providers/'
      path: '/providers'
      fullPath: '/providers/'
      preLoaderRoute: typeof AuthProvidersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tpas/': {
      id: '/_auth/tpas/'
      path: '/tpas'
      fullPath: '/tpas/'
      preLoaderRoute: typeof AuthTpasIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_portal/portal/bank-accounts': {
      id: '/_portal/portal/bank-accounts'
      path: '/portal/bank-accounts'
      fullPath: '/portal/bank-accounts'
      preLoaderRoute: typeof PortalPortalBankAccountsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/notifications': {
      id: '/_portal/portal/notifications'
      path: '/portal/notifications'
      fullPath: '/portal/notifications'
      preLoaderRoute: typeof PortalPortalNotificationsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/summary': {
      id: '/_portal/portal/summary'
      path: '/portal/summary'
      fullPath: '/portal/summary'
      preLoaderRoute: typeof PortalPortalSummaryRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_auth/agents-brokers/$agentBrokerId/': {
      id: '/_auth/agents-brokers/$agentBrokerId/'
      path: '/agents-brokers/$agentBrokerId'
      fullPath: '/agents-brokers/$agentBrokerId/'
      preLoaderRoute: typeof AuthAgentsBrokersAgentBrokerIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents-brokers/$agentBrokerId/$section': {
      id: '/_auth/agents-brokers/$agentBrokerId/$section'
      path: '/agents-brokers/$agentBrokerId/$section'
      fullPath: '/agents-brokers/$agentBrokerId/$section'
      preLoaderRoute: typeof AuthAgentsBrokersAgentBrokerIdSectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/entities/$entityId/': {
      id: '/_auth/entities/$entityId/'
      path: '/entities/$entityId'
      fullPath: '/entities/$entityId/'
      preLoaderRoute: typeof AuthEntitiesEntityIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/entities/$entityId/$section': {
      id: '/_auth/entities/$entityId/$section'
      path: '/entities/$entityId/$section'
      fullPath: '/entities/$entityId/$section'
      preLoaderRoute: typeof AuthEntitiesEntityIdSectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/general-agents/$generalAgentId/': {
      id: '/_auth/general-agents/$generalAgentId/'
      path: '/general-agents/$generalAgentId'
      fullPath: '/general-agents/$generalAgentId/'
      preLoaderRoute: typeof AuthGeneralAgentsGeneralAgentIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/general-agents/$generalAgentId/$section': {
      id: '/_auth/general-agents/$generalAgentId/$section'
      path: '/general-agents/$generalAgentId/$section'
      fullPath: '/general-agents/$generalAgentId/$section'
      preLoaderRoute: typeof AuthGeneralAgentsGeneralAgentIdSectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/providers/$providerId/': {
      id: '/_auth/providers/$providerId/'
      path: '/providers/$providerId'
      fullPath: '/providers/$providerId/'
      preLoaderRoute: typeof AuthProvidersProviderIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/providers/$providerId/$section': {
      id: '/_auth/providers/$providerId/$section'
      path: '/providers/$providerId/$section'
      fullPath: '/providers/$providerId/$section'
      preLoaderRoute: typeof AuthProvidersProviderIdSectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tpas/$tpaId/': {
      id: '/_auth/tpas/$tpaId/'
      path: '/tpas/$tpaId'
      fullPath: '/tpas/$tpaId/'
      preLoaderRoute: typeof AuthTpasTpaIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tpas/$tpaId/$section': {
      id: '/_auth/tpas/$tpaId/$section'
      path: '/tpas/$tpaId/$section'
      fullPath: '/tpas/$tpaId/$section'
      preLoaderRoute: typeof AuthTpasTpaIdSectionRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminAccountPopulationRoute: typeof AuthAdminAccountPopulationRoute
  AuthAdminPermissionsRoute: typeof AuthAdminPermissionsRoute
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminAccountPopulationRoute: AuthAdminAccountPopulationRoute,
  AuthAdminPermissionsRoute: AuthAdminPermissionsRoute,
  AuthAdminUsersRoute: AuthAdminUsersRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthKitchenSinkRoute: typeof AuthKitchenSinkRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthInvoicesInvoiceIdRoute: typeof AuthInvoicesInvoiceIdRoute
  AuthAgentsBrokersIndexRoute: typeof AuthAgentsBrokersIndexRoute
  AuthClientsIndexRoute: typeof AuthClientsIndexRoute
  AuthEntitiesIndexRoute: typeof AuthEntitiesIndexRoute
  AuthEntityContractsIndexRoute: typeof AuthEntityContractsIndexRoute
  AuthGeneralAgentsIndexRoute: typeof AuthGeneralAgentsIndexRoute
  AuthInvoicesIndexRoute: typeof AuthInvoicesIndexRoute
  AuthProvidersIndexRoute: typeof AuthProvidersIndexRoute
  AuthTpasIndexRoute: typeof AuthTpasIndexRoute
  AuthAgentsBrokersAgentBrokerIdSectionRoute: typeof AuthAgentsBrokersAgentBrokerIdSectionRoute
  AuthEntitiesEntityIdSectionRoute: typeof AuthEntitiesEntityIdSectionRoute
  AuthGeneralAgentsGeneralAgentIdSectionRoute: typeof AuthGeneralAgentsGeneralAgentIdSectionRoute
  AuthProvidersProviderIdSectionRoute: typeof AuthProvidersProviderIdSectionRoute
  AuthTpasTpaIdSectionRoute: typeof AuthTpasTpaIdSectionRoute
  AuthAgentsBrokersAgentBrokerIdIndexRoute: typeof AuthAgentsBrokersAgentBrokerIdIndexRoute
  AuthEntitiesEntityIdIndexRoute: typeof AuthEntitiesEntityIdIndexRoute
  AuthGeneralAgentsGeneralAgentIdIndexRoute: typeof AuthGeneralAgentsGeneralAgentIdIndexRoute
  AuthProvidersProviderIdIndexRoute: typeof AuthProvidersProviderIdIndexRoute
  AuthTpasTpaIdIndexRoute: typeof AuthTpasTpaIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthKitchenSinkRoute: AuthKitchenSinkRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthInvoicesInvoiceIdRoute: AuthInvoicesInvoiceIdRoute,
  AuthAgentsBrokersIndexRoute: AuthAgentsBrokersIndexRoute,
  AuthClientsIndexRoute: AuthClientsIndexRoute,
  AuthEntitiesIndexRoute: AuthEntitiesIndexRoute,
  AuthEntityContractsIndexRoute: AuthEntityContractsIndexRoute,
  AuthGeneralAgentsIndexRoute: AuthGeneralAgentsIndexRoute,
  AuthInvoicesIndexRoute: AuthInvoicesIndexRoute,
  AuthProvidersIndexRoute: AuthProvidersIndexRoute,
  AuthTpasIndexRoute: AuthTpasIndexRoute,
  AuthAgentsBrokersAgentBrokerIdSectionRoute:
    AuthAgentsBrokersAgentBrokerIdSectionRoute,
  AuthEntitiesEntityIdSectionRoute: AuthEntitiesEntityIdSectionRoute,
  AuthGeneralAgentsGeneralAgentIdSectionRoute:
    AuthGeneralAgentsGeneralAgentIdSectionRoute,
  AuthProvidersProviderIdSectionRoute: AuthProvidersProviderIdSectionRoute,
  AuthTpasTpaIdSectionRoute: AuthTpasTpaIdSectionRoute,
  AuthAgentsBrokersAgentBrokerIdIndexRoute:
    AuthAgentsBrokersAgentBrokerIdIndexRoute,
  AuthEntitiesEntityIdIndexRoute: AuthEntitiesEntityIdIndexRoute,
  AuthGeneralAgentsGeneralAgentIdIndexRoute:
    AuthGeneralAgentsGeneralAgentIdIndexRoute,
  AuthProvidersProviderIdIndexRoute: AuthProvidersProviderIdIndexRoute,
  AuthTpasTpaIdIndexRoute: AuthTpasTpaIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PortalRouteChildren {
  PortalPortalBankAccountsRoute: typeof PortalPortalBankAccountsRoute
  PortalPortalNotificationsRoute: typeof PortalPortalNotificationsRoute
  PortalPortalSummaryRoute: typeof PortalPortalSummaryRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalPortalBankAccountsRoute: PortalPortalBankAccountsRoute,
  PortalPortalNotificationsRoute: PortalPortalNotificationsRoute,
  PortalPortalSummaryRoute: PortalPortalSummaryRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  NoAccessRoute: NoAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
